import BlockScriptingMap from './block_scripting';
import BasicPlatformerMap from './basic_platformer';
import KillerBlocksMap from './killer_blocks';

export default [
  {
    map: BasicPlatformerMap,
    title: 'Basic Platformer',
  },
  {
    map: BlockScriptingMap,
    title: 'Block Scripting',
  },
  {
    map: KillerBlocksMap,
    title: 'Custom Block Rendering',
  },
];
